import React, {memo} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import EmptyCard from './emptyCard.js'
import MediaCard from './mediaCard.js'

const SIZES = {
  SMALL: 'small',
  LARGE: 'large'
}

const SIDE_BORDER = {
  LEFT_ROUNDED: 'leftRounded',
  RIGHT_ROUNDED: 'rightRounded'
}

const DEFAULT_SIZE = SIZES.LARGE

const BASE_CLASS = 'mt-CardAddVehicle'

const CardAddVehicle = ({
  addVehicle = () => {},
  removeVehicle = () => {},
  sideBorder,
  size = DEFAULT_SIZE,
  vehicle
}) => {
  const hasVehicle = Boolean(vehicle)
  const isSmallSize = size === SIZES.SMALL

  const sideBorderClass = `${BASE_CLASS}--${sideBorder}`
  const sizeClass = `${BASE_CLASS}--${size}`

  const PRIMARY_CLASS = cx(BASE_CLASS, sizeClass, {
    [sideBorderClass]: sideBorder
  })

  const mediaCardProps = {
    baseClass: BASE_CLASS,
    ...(hasVehicle && {vehicle}),
    isSmallSize
  }

  const emptyCardProps = {
    baseClass: BASE_CLASS,
    isSmallSize
  }

  const _handleAddVehicle = () => addVehicle()
  const _handleRemoveVehicle = () => removeVehicle()

  return (
    <div className={PRIMARY_CLASS}>
      {hasVehicle ? (
        <MediaCard {...mediaCardProps} onRemoveVehicle={_handleRemoveVehicle} />
      ) : (
        <EmptyCard {...emptyCardProps} onAddVehicle={_handleAddVehicle} />
      )}
    </div>
  )
}

CardAddVehicle.displayName = 'CardAddVehicle'
CardAddVehicle.propTypes = {
  addVehicle: PropTypes.func,
  removeVehicle: PropTypes.func,
  sideBorder: PropTypes.oneOf(Object.values(SIZES)),
  size: PropTypes.oneOf(Object.values(SIZES)),
  vehicle: PropTypes.object
}

const MemoCardAddVehicle = memo(CardAddVehicle)
MemoCardAddVehicle.displayName = 'MemoCardAddVehicle'
export default MemoCardAddVehicle

export {SIZES as CardAddVehiclesSizes}
export {SIDE_BORDER as CardAddVehiclesSideBorderTypes}
